import React from 'react';
import { formatPrice } from '../../../../utils';

const calculateTotal = (subtotal, couponDiscount, methodDiscountPercentage, total) => {
  const methodDiscount = methodDiscountPercentage * total;
  return subtotal - couponDiscount - methodDiscount;
};

const PriceBlock = ({ paymentMethods, purchaseSummary, paymentMethodSlug }) => {
  const { subtotal, coupon_discount, total } = purchaseSummary;
  const paymentMethod = paymentMethods.find(method => method.slug === paymentMethodSlug);
  const methodDiscountPercentage = paymentMethod && paymentMethod.discount ? paymentMethod.discount / 100 : 0;

  const finalTotal = coupon_discount > 0 
    ? calculateTotal(subtotal, coupon_discount, methodDiscountPercentage, total)
    : calculateTotal(subtotal, 0, methodDiscountPercentage, subtotal);

  return (
    <div className="price">
      <span>
        <b>Total:</b> R$ {formatPrice(finalTotal)}
      </span>
    </div>
  );
};

export default PriceBlock;



// WEBPACK FOOTER //
// ./src/components/purchase/payment_info/mobile/PriceBlock.jsx